import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Auth } from 'aws-amplify'

// @mui material components
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import LinearProgress from '@mui/material/LinearProgress'

// Soft UI Dashboard PRO React example components
import OnboardingLayout from 'components/LayoutContainers/OnboardingLayout'
import OnboardingNavbar from 'components/Navbars/OnboardingNavbar'
import OnboardingFooter from 'components/OnboardingFooter'
import { useNavigate } from 'react-router-dom'
import { callZapier } from 'utils/zapier/callZapier'

import circleBG from 'assets/images/circles.svg'
import parcoDog from 'assets/images/parcoDog.svg'
import laptopMockup from 'assets/images/laptopMockup_Jun20.png'
import phoneMockup from 'assets/images/phoneMockup.png'
import { Link } from '@mui/material'
import { checkUserLoggedIn } from 'utils/aws/authService'
import Testimonials from 'components/Testimonials'
import ScoreCard from 'components/ScoreCard'

function OnboardingSelectorHyper() {
  const { intakeState, updateUser, updateIntakeStateAtKey } =
    useContext(IntakeContext)
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])

  const [isMobile, setIsMobile] = useState(window.innerWidth < 575)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 575)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const zapierNotificationOfLogin = async () => {
      try {
        callZapier({
          user: intakeState,
          hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3fx8p4q/',
          payload: {
            user: {
              firstName: intakeState.firstName
                ? intakeState.firstName
                : 'Name Not',
              lastName: intakeState.lastName
                ? intakeState.lastName
                : 'Yet Submitted',
              email: intakeState.email,
            },
          },
          sendNotification: false,
        })
      } catch (err) {
        console.log(err)
      }
    }
    zapierNotificationOfLogin()
    checkUserLoggedIn()
    return () => {}
  }, [intakeState, navigate])

  //make a new page that is a navigation page for dashboard or onboarding using the useNaviate function

  return (
    <OnboardingLayout>
      {/* <DashboardNavbar /> */}
      <OnboardingNavbar />
      <Box sx={{ width: '100%', overflow: 'hidden', margin: 'auto' }}>
        <LinearProgress
          variant="determinate"
          value={0}
          color="dark"
          sx={{
            height: '8px',
            overflow: 'hidden',
            borderRadius: '0px',
          }}
        />
      </Box>
      <Box
        sx={{
          minHeight: { xs: 'calc(100vh - 417px)', sm: 'calc(100vh - 425px)' },
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={6}>
            <Box
              p={{ xs: 4, md: 12 }}
              pb={{ xs: 8, md: 12 }}
              sx={{
                background: '#fff',
                minHeight: { lg: 'calc(100vh - 427px)' },
                paddingBottom: { lg: '100px' },
                boxShadow: '4px 4px 25px -8px rgba(0, 0, 0, 0.2)',
              }}
            >
              <Box sx={{ textAlign: 'left' }}>
                <Box mb={{ xs: 0, md: 1 }}>
                  <Typography
                    variant="h2"
                    fontWeight="900"
                    fontSize={isMobile ? '30px' : '40px'}
                  >
                    On track to Retire?
                  </Typography>
                </Box>
                <Box mb={{ xs: 2, md: 3 }}>
                  <Typography
                    variant="h2"
                    fontWeight="400"
                    fontSize={isMobile ? '30px' : '40px'}
                  >
                    Find out in 30 seconds
                  </Typography>
                </Box>
                <Typography variant="body1" sx={{ lineHeight: '1.2' }} mb={3}>
                  Answer 7 questions to see if you are Retirement ready.
                  Retirement planning shouldn't need to be complicated.
                </Typography>
                {/* <img
                  src={parcoDog}
                  style={{
                    maxWidth: '400px',
                    display: 'block',
                    margin: 'auto',
                  }}
                /> */}
              </Box>
              <Box
                mt={{ xs: 3, md: 5 }}
                mb={isMobile ? 0 : 20}
                width="100%"
                display="flex"
                gap={1}
              >
                <Link href="/quick-onboarding">
                  <Button variant="parcoRounded">Get Started</Button>
                </Link>
                <Link href="/dashboard">
                  <Button variant="parcoRounded" color="outline">
                    Sign In
                  </Button>
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              // backgroundImage: `url(${circleBG})`,
              // backgroundPosition: 'center',
              backgroundColor: '#f9f9f9',
            }}
          >
            <Grid
              justifyContent="center"
              sx={{
                px: { xs: 4, md: 12 },
                pt: { xs: 6, md: 12 },
              }}
              pb={{ xs: 12, md: 24 }}
            >
              {/* <img
                src={isMobile ? phoneMockup : laptopMockup}
                style={{
                  maxWidth: '800px',
                  width: '100%',
                  display: 'block',
                  margin: 'auto',
                }}
              /> */}
              <ScoreCard
                key={'scoreCard'}
                value={44}
                goal={`November 2027`}
                type="retirement"
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Testimonials />
      {/* <Footer /> */}
      <OnboardingFooter />
    </OnboardingLayout>
  )
}

export default OnboardingSelectorHyper
